<template>
  <div class="container is-fluid pt-4">
    <b-field
      class="notification container"
      label="Enter binary number"
      :type="hasErrorInInput"
      :message="hasErrorMessage"
    >
      <b-input class="container" v-model="userInput"/>

      <b-button class="ml-5" type="is-link" @click="convertBinaryToDecimal">Convert to decimal</b-button>
    </b-field>
    <compute-result :result="result" v-if="showResult"/>
  </div>
</template>

<script>
import decimalConverter from "@/utils/decimal-converter";
import ComputeResult from "./ComputeResult";

export default {
  name: "DecimalConverter",
  components: {
    ComputeResult
  },

  data() {
    return {
      userInput: "",
      result: 0,
      showResult: false
    };
  },

  computed: {
    invalidInputLength() {
      return this.userInput.length > 8;
    },

    hasErrorInInput() {
      return this.invalidInputLength ? "is-danger" : null;
    },

    hasErrorMessage() {
      return this.invalidInputLength
        ? "Input must not be more than 8 characters"
        : null;
    }
  },

  methods: {
    convertBinaryToDecimal() {
      this.clearFormat();

      this.result = decimalConverter(this.userInput);

      if (this.result === null) {
        return;
      }

      this.showResult = true;
    },

    clearFormat() {
      this.result = 0;
      this.showResult = false;
    }
  }
};
</script>
